import { NmsWizardStepModel } from "@nms-angular-toolkit/nms-wizard";
import { Device } from "@nms-ng2/app/modules/device/device-backup/device-backup.models";
import { MuxDemuxData, PortData, SlotData } from "./end-step-circuit-dwdm.model";
import { CircuitChangesCallbacks, CircuitChangeToBeApplied } from "../../../dwdm-circuit.model";

/**
 * Representa o modelo do step Ends do DwdmCircuitWizard.
 */
export class EndsStepModel extends NmsWizardStepModel {
    circuitId?: number;
    aEndDevice: Device;
    aEndSlots: SlotData[];
    aEndPorts: PortData[];
    aEndHasMux: boolean;
    aEndMux: MuxDemuxData;
    zEndDevice: Device;
    zEndSlots: SlotData[];
    zEndPorts: PortData[];
    zEndHasMux: boolean;
    zEndMux: MuxDemuxData;

    constructor() {
        super();
        this.aEndSlots = [];
        this.aEndPorts = [];
        this.aEndHasMux = false;
        this.aEndMux = null;
        this.zEndSlots = [];
        this.zEndPorts = [];
        this.zEndHasMux = false;
        this.zEndMux = null;
    }
}

/**
 * Define as possíveis alterações que o usuário pode fazer no passo de Ends.
 */
export type EndpointsChanges =
    | "addDevice"
    | "changeEndSlot"
    | "changeEndPort"
    | "changeAEndMuxCheck"
    | "changeZEndMuxCheck"
    | "changeEndMuxChange";

/**
 * Tipo que define uma mudança que o usuário realizou no passo de Ends.
 *
 * Contém o nome da alteração e os valores necessários para
 * realizar a alteração no momento apropriado.
 */
export type EndpointsChangesToBeApplied = CircuitChangeToBeApplied<EndpointsChanges>;

/**
 * Define as ações que devem ser realizadas para aplicar cada mudança possível no passo de Ends.
 */
export type EndpointsChangesCallbacks = CircuitChangesCallbacks<EndpointsChanges>;
